<!-- Show all months of the current year -->
<section class="ds-flex ds-flex-wrap mb-4 ds-align-middle ds-m-auto">
  <span
    *ngFor="let month of months"
    [attr.tabindex]="isDisabled(month) ? '-1' : '0'"
    class="
      ds-w-1/3
      ds-self-left
      ds-text-center
      ds-cursor-pointer
      ds-py-xs
      ds-my-sm
      ds-border-2
      ds-border-transparent
      ds-capitalize
      hover:ds-bg-background-grey hover:ds-rounded-full
      active:!ds-bg-primary-blue-50
      focus:ds-bg-primary-blue-50 focus:ds-rounded-full focus:ds-outline-none
    "
    [ngClass]="{
      '
      !ds-bg-primary-blue 
        ds-rounded-full ds-tracking-wide   
      ds-text-primary-white 
        ds-font-bold':
        isSelected(month),

      'ds-text-primary-gray-70 
       ds-cursor-not-allowed
       ds-pointer-events-none':
        isDisabled(month)
    }"
    (click)="selectMonthRange(month)"
    (keydown.enter)="selectMonthRange(month)"
  >
    {{ month | date: "LLLL" }}
  </span>
</section>
